<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="title">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{title}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        style="max-height: 40vh"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div ref="selectRef">
              <AccessibleElSelect
                v-model="form.users"
                prop="users"
                :options="usersForAccessibleSelect"
                :isMultiple="true"
                :isDisabled="isLoadingSelect"
                @visible-change="onExpand"
                @change="onChangeInput"
                id-prefix="userlinkusersdialog"
              >
                <template slot="label">{{$t('app.users')}}</template>
              </AccessibleElSelect>
            </div>
          </div>

          <div class="lg:mb-2 ">
            <label class="text-sm font-semibold text-secondary-600 block mb-1">{{labelOrigen}}
              <el-radio-group v-model="form.radioOrigen" class="flex flex-col md:inline-block">
                <el-radio-button :label="0">Todos</el-radio-button>
                <el-radio-button class="border-l-2 dark:border-darkblue-300" :label="1">Temporales</el-radio-button>
                <el-radio-button class="border-l-2 dark:border-darkblue-300" :label="2">Permanentes</el-radio-button>
              </el-radio-group>
            </label>
          </div>
          
          <div class="lg:mb-2">
            <label class="text-sm font-semibold text-secondary-600 block mb-1">{{labelDestino}}
              <el-radio-group v-model="form.radioDestino" class="flex flex-col md:inline-block">
                <el-radio-button 
                  :label="0"
                  v-popover:popovermantener
                  >
                  Mantener estado de origen
                </el-radio-button>
                <el-popover
                  ref="popovermantener"
                  placement="left"
                  width="300"
                  :value="form.radioDestino === 0 && form.radioOrigen !== 1"
                  popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
                  trigger="manual"
                  >
                  <div class="break-normal">Es posible que se sobreescriban los vínculos 
                  temporales como permanentes en los usuarios 
                  destinos si estos usuarios ya tienen estos 
                  vínculos como temporales.</div>
                </el-popover>
                <el-radio-button class="border-l-2 dark:border-darkblue-300" :label="1">Temporales</el-radio-button>
                <el-radio-button 
                  class="border-l-2 dark:border-darkblue-300" 
                  :label="2"
                  v-popover:popoverpermanentes
                  >
                  Permanentes
                </el-radio-button>
                <el-popover
                  ref="popoverpermanentes"
                  placement="right"
                  width="300"
                  :value="form.radioDestino === 2"
                  popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
                  trigger="manual"
                  >
                  <div class="break-normal">Los vínculos ya existentes en los 
                  usuarios destinos se sobreescribirán
                  como permanentes.</div>
                </el-popover>
              </el-radio-group>
            </label>
          </div>

        </el-form>
      </div>
    </template>
    <template slot="footer">
        <base-button mode="secondary-phantom-blue"
          class="w-full"
          v-if="!isAllSelected" 
          :disabled="!isLoadedData || isLoadingSelect || isEmptyList" 
          :text="$t('app.select_all')" 
          @click="handleSelectAll" 
          :loading="isLoadingSelect"
          />
        <base-button v-else :text="$t('app.unselect_all')" mode="secondary-phantom-blue"
          class="w-full"
          @click="handleUnSelectAll"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect || isEmptyList"
          />
          <div class="w-48 "></div>
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" 
          class="w-full"
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply" 
          :loading="isLoadingSelect"
          :disabled="isLoadingSelect"/>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { getAllUsers } from '@/services/configurations/getAllUsers'
import { i18n } from '@/i18n'

export default
{
  name: 'user-link-users-dialog',
  components: {
    BaseDialogButton,
    AccessibleElSelect
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    idUsuario: {
      type: [Number, String],
      default: -1
    },
    title: {
      type: String,
      default: '',
    },
    labelOrigen: {
      type: String,
      default: i18n.t('app.origen')
    },
    labelDestino: {
      type: String,
      default: i18n.t('app.destino')
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      form: {
        users: [],
        radioOrigen: 2,
        radioDestino: 1,
      },
      users: [],
      isLoadedData: false,
      loadingActionSelect: false,
      loadingActionUnSelect: false
    }
  },
  mounted: async function () {
    this.isLoadedData = false
    const data = await getAllUsers({ idUsuario: this.idUsuario })
    if (data.blnError === true) {
      this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
    } else {
      data.respuesta.forEach(row => {
        this.users.push({ value: row.IdUsuario, label: row.Usuario })
      })
    }
    this.isLoadedData = true
  },
  computed: {
    isEmptyList: function () {
      return this.users === undefined || this.users === null || this.users.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    isAllSelected: function () {
      if (this.users.length === this.form.users.length) return true
      else return false
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    usersForAccessibleSelect: function () {
      return this.users.map(item => ({
        id: item.value,
        name: item.label,
        value: item.value
      }))
    }
  },
  methods: {
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          this.heightSelect = document.getElementsByClassName('el-scrollbar')[0]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRef.clientHeight
      }, 100)
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.users = []
    },
    apply: function () {
      this.isOpen = !this.isOpen
      this.$emit('applyDialog', this.form)
      this.form.users = []
    },
    handleSelectAll: async function () {
      await this.handleUnSelectAll()
      this.loadingActionSelect = true
      this.users.forEach(element => {
        setTimeout(() => {
          this.form.users.push(element.value)
          if (this.form.users.length === this.users.length) {
            this.loadingActionSelect = false
            this.loadingActionUnSelect = false
          }
        }, 100)
      })
    },
    handleUnSelectAll: async function () {
      this.loadingActionUnSelect = true
      const staticLength = this.form.users.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.form.users.pop()
          if (this.form.users.length === 0) this.loadingActionUnSelect = false
        }, 100)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
